import { render, staticRenderFns } from "./TarjetasVisar.vue?vue&type=template&id=199259df&scoped=true"
import script from "./TarjetasVisar.vue?vue&type=script&lang=ts"
export * from "./TarjetasVisar.vue?vue&type=script&lang=ts"
import style0 from "./TarjetasVisar.vue?vue&type=style&index=0&id=199259df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199259df",
  null
  
)

export default component.exports